import { getColumns, getDrawerFilters } from './helpers'
import { useMemo, useState } from 'react'
import { toTableRowItems } from './serializers'
import { useNavigate } from 'react-router-dom'
import { Grid } from '@mui/material'
import s from '../../../commonStyles.modules.scss'
import { useQuery } from 'react-query'
import { useNotification } from 'hooks'
import { formatErrorMessage } from 'utils/formatting'
import { makeCoreGetRequest } from 'utils/api'
import { Table } from 'components/core-ui/Table'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { getShopOptions } from '../../api'

const MetiResponse = ({ isHistorical }) => {
  const [tableItems, setTableItems] = useState<DSMetiFile[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const { showNotification } = useNotification()
  const navigate = useNavigate()

  const columns = useMemo(
    () =>
      getColumns(
        navigate,
        isHistorical
      ),
    [isHistorical]
  )

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)

    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: isHistorical
            ? '/shop-reception/ds-meti-integration-archive'
            : '/shop-reception/ds-meti-integration',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
      setIsLoading(false)
    }
  }

  const { data: shopCodes } = getShopOptions(showNotification)

  const { data: statusList, isLoading: isStatusListLoading } = useQuery(
    ['status-list'],
    async () => {
      const data = await makeCoreGetRequest(
        '/shop-reception/metiIntegrationFile/metiFileStatusList'
      )
      return data?.map(item => ({
        label: item,
        value: item
      }))
    },
    {
      onError: error => {
        showNotification({
          message: `A apărut o eroare la obtinerea statusurilor. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const filters = useMemo(() => {
    return getDrawerFilters(shopCodes, statusList)
  }, [shopCodes, statusList])

  return (
    <Grid className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        filters={filters}
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </Grid>
  )
}

export default MetiResponse
